import { Fragment } from 'react'
import { useFormikContext } from 'formik'

import { CalendarDayLoadWarning } from '../../../CalendarDayLoad'
import { getEntityActionTypeSelectOptions } from '../../../Entity'
import { FormFieldsContainer } from '../../../Form'
import {
  FormikEntityActionConfigFields,
  useFormikEntityActionConfigFieldsClearFields,
} from '../../../Formik'
import { REQUESTS_EDIT_DUE_DATE_FIELD_NAME } from '../RequestEditDueDateModal.constants'
import { getRequestEditDueDateEmptyValues } from '../RequestEditDueDateModal.utils'
import { RequestEditDueDateModalDateField } from '../RequestEditDueDateModalDateField'

function RequestEditStatusModalMassActionFields({
  actionTypes = Object.values(getEntityActionTypeSelectOptions()),
  dayLoadProps,
  typeSelectProps,
}) {
  const { errors, setFieldValue, values } = useFormikContext()

  const { actionTypeValueIsRemoveAll } =
    useFormikEntityActionConfigFieldsClearFields({
      emptyValues: getRequestEditDueDateEmptyValues(),
    })

  function handleSelectDayLoadDate(date) {
    setFieldValue(REQUESTS_EDIT_DUE_DATE_FIELD_NAME, date)
  }

  return (
    <FormFieldsContainer>
      <FormikEntityActionConfigFields
        typeSelectProps={{
          ...typeSelectProps,
          error: errors[REQUESTS_EDIT_DUE_DATE_FIELD_NAME],
          options: actionTypes,
        }}
      >
        <RequestEditDueDateModalDateField
          Container={Fragment}
          disabled={actionTypeValueIsRemoveAll}
          withoutDeadlineFieldName={null}
          withoutDeadlineLabel={null}
        />
      </FormikEntityActionConfigFields>
      {dayLoadProps ? (
        <CalendarDayLoadWarning
          {...dayLoadProps}
          value={
            actionTypeValueIsRemoveAll
              ? null
              : values[REQUESTS_EDIT_DUE_DATE_FIELD_NAME]
          }
          onSelectDate={handleSelectDayLoadDate}
        />
      ) : null}
    </FormFieldsContainer>
  )
}

export default RequestEditStatusModalMassActionFields
